import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ConfigService } from '../../../../infrastructure/services/config.service';
import { AlertService, GrowlType } from '../../../../infrastructure/services/alert.service';
import { LoaderService } from '../../../../infrastructure/services/loader.service';
import { Router, ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { Subscription } from 'rxjs';
import { TreeViewComponent } from 'app/helpers/components/treeView/treeView.component';

@Component({
  selector: 'sx-exportar-initializer',
  templateUrl: './exportar.initializer.component.html',
})
export class ExportarInitializerComponent implements OnInit, OnDestroy {
  @ViewChild('tree') tree: TreeViewComponent;
  data: any;
  subsGetInitializerExport: Subscription;
  subsGetInitializerExportDownloadFile: Subscription;
  codSistema: string;
  
  constructor(private aRoute: ActivatedRoute,
    private configService: ConfigService,
    private alertService: AlertService,
    private loaderService: LoaderService) { }

  ngOnInit() {
    this.aRoute.params.subscribe(params => {
      this.codSistema = params['codsistema'];
      this.subsGetInitializerExport = this.configService.getInitializerExport(this.codSistema)
        .subscribe(data => this.data = data.config);
    });
}

  /**
   * Se remueven las subscripciones para cancelar los request pendientes.
   */
  ngOnDestroy() {
    if (this.subsGetInitializerExport)  {
      this.subsGetInitializerExport.unsubscribe();
    }

    if (this.subsGetInitializerExportDownloadFile) {
      this.subsGetInitializerExportDownloadFile.unsubscribe();
    }
  }

  expandirTodos() {
    this.tree.expandAll();
  }

  colapsarTodos() {
    this.tree.collapseAll();
  }

  checkAll() {
    this.tree.checkAll();
  }

  uncheckAll() {
    this.tree.uncheckAll();
  }

  exportar() {
    const items = this.tree.getSelected();
    this.configService.postInitializerExportCreateFile(items)
      .then(data => {
        this.getUrlDownloadFile(data);
      });
  }

  exportarTablasDeSistema() {
    this.configService.postInitializerExportSystemTablesCreateFile(this.codSistema)
      .then(data => {
        this.getUrlDownloadFile(data, 'EXPORT_SYSTEMTABLES.xml');
      });
  }

  getUrlDownloadFile(data, nombreArchivo = null) {
    if (data.isOk) {
      this.subsGetInitializerExportDownloadFile = this.configService.getInitializerExportDownloadFile(data.tempFileName)
        .subscribe(data => {
          this.convertirYDescargar(data);
          this.alertService.showGrowl({
            type: GrowlType.SUCCESS,
            body: 'EXPORTACION_EXITOSA'
          });
        });
    }
  }

  download(content, filename, contentType) {
    const blob = new Blob([content], { 'type': contentType });
    saveAs(blob, filename);
  }

  convertirYDescargar(data) {
    // base64 To ArrayBuffer
    const binaryString = atob(data.fileContents);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    // -------

    this.download(bytes, data.fileDownloadName, data.contentType);
  }

  onTreeNodeExpanded(node: any) {
    if(node.key.tableName != "SX_NOTABLENAME") {
      this.configService.getExportNode(node.key, node.checked)
          .subscribe(
        data => {
          node.append(data.config);
        }
      )
    }
  }
}




// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/initializer/exportar/exportar.initializer.component.ts